<template>
  <section class="experience-wrapper--section-provider">
    <div class="section-provider-top d--grid">
      <LadProviderImage :show-rate="false" />
      <LadProviderDescription :email="local.email" :phone="local.phone" />
    </div>
    <p class="experience--provider-text2">{{ exLocal.description }}</p>

    <LadProviderContact
      v-if="local.email || local.phone"
      :email="local.email"
      :phone="local.phone"
      base="experience.provider"
      class="experience--provider-text2"
    />
  </section>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'LadSectionProvider',
  components: {
    LadProviderImage: () =>
      import(
        /* webpackChunkName: "lad-provider-image" */ '@/components/provider/image'
      ),
    LadProviderDescription: () =>
      import(
        /* webpackChunkName: "lad-provider-description" */ '@/components/provider/description'
      ),
    LadProviderContact: () =>
      import(
        /* webpackChunkName: "lad-provider-contact" */ '@/components/provider/contact'
      ),
  },
  props: {
    local: {
      type: Object,
      default() {
        return { email: null, phone: null }
      },
    },
  },
  computed: {
    ...mapState('experience', {
      exLocal: (state) => state.local,
    }),
  },
}
</script>

<style lang="scss">
.experience-wrapper--section-provider {
  margin-bottom: 20px;
  .section-provider-top {
    grid-template-columns: 25% 1fr;
    grid-gap: 10px;
  }
  .experience--provider-text2 {
    @media screen and (min-width: 601px) {
      display: none;
    }
  }
}

.oldBrowsers {
  .experience-wrapper--section-provider {
    .section-provider-top {
      .experience--provider-image {
        width: 30%;

        img {
          margin-right: 10px;
        }
      }
    }
  }
}
</style>
